import { gql } from '@apollo/client'

import type { SquadResponse } from '@/lib/apollo/model/squad'

export type QueryVars = {
  userId: string
}

export type ExecutiveResponse = {
  fullName: string
  skillLevel: number | null
  squads: SquadResponse[]
  primaryEmail: string
}

export type Response = {
  getExecutive: ExecutiveResponse
}

const query = gql`
  query ($userId: String!) {
    getExecutive(userId: $userId) {
      fullName
      skillLevel
      squads
      primaryEmail
    }
  }
`

export default query
